module.exports = __webpack_public_path__ + "open-sans-latin-700italic.8139fb487665fa52cae6.eot";


//////////////////
// WEBPACK FOOTER
// /Users/herbert/dev/awesum/awesum-web/~/typeface-open-sans/files/open-sans-latin-700italic.eot
// module id = ../../../../typeface-open-sans/files/open-sans-latin-700italic.eot
// module chunks = 1 3